import React from "react";
import PrivateRoute from "common/routes/PrivateRoute/PrivateRoute";

export default function ConciliacionProtectedRoute(props){
    return <PrivateRoute allowedroles={["conciliacion",'administrator','recepcion']}>
        {props.children}
    </PrivateRoute>;
}